























import CaldateModel from "@/ts/models/caldateClass";
import { defineComponent } from "@vue/composition-api";
import CaldateChip from "../../atoms/caldate/CaldateChip.vue";
import CurrentOutlined from "@c/molecules/current/CurrentOutlined.vue";

export default defineComponent({
  components: {
    CaldateChip,
    CurrentOutlined
  },

  props: {
    caldates: {
      type: Array as () => Array<CaldateModel>,
      default: () => []
    },
    label: {
      type: String,
      default: "Caldates"
    },
    editable: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },

  name: "",

  setup() {
    return {};
  }
});
